import Papa from 'papaparse';

export const TOOLS_CSV_COLUMNS = [
    'mcp_server_id',
    'tool_name',
    'description',
    'parameters',
    'supports_read',
    'supports_write',
    'supports_delete',
];

const BOOLEAN_FIELDS = ['supports_read', 'supports_write', 'supports_delete'];

export const validateToolRow = (row) => {
    const fieldErrors = {};

    const serverId = Number(row.mcp_server_id);
    if (!Number.isInteger(serverId) || serverId <= 0) {
        fieldErrors.mcp_server_id = 'Must be a positive integer';
    }

    const toolName = typeof row.tool_name === 'string' ? row.tool_name.trim() : '';
    if (!toolName) {
        fieldErrors.tool_name = 'Tool name is required';
    } else if (toolName.length > 255) {
        fieldErrors.tool_name = 'Max 255 characters';
    }

    BOOLEAN_FIELDS.forEach((field) => {
        if (!['0', '1', 0, 1].includes(row[field])) {
            fieldErrors[field] = 'Must be 0 or 1';
        }
    });

    return fieldErrors;
};

export const parseToolsCsvFile = (file) => {
    return new Promise((resolve) => {
        Papa.parse(file, {
            header: true,
            skipEmptyLines: 'greedy',
            complete: (result) => {
                const fileErrors = [];

                if (result.errors && result.errors.length > 0) {
                    result.errors.slice(0, 3).forEach((e) => {
                        fileErrors.push(`Row ${e.row + 1}: ${e.message}`);
                    });
                }

                const headers = result.meta.fields ?? [];
                const missingHeaders = TOOLS_CSV_COLUMNS.filter((c) => !headers.includes(c));
                if (missingHeaders.length > 0) {
                    fileErrors.push(`Missing required column(s): ${missingHeaders.join(', ')}`);
                }

                if (fileErrors.length > 0) {
                    resolve({ rows: [], fileErrors });
                    return;
                }

                const rows = result.data.map((raw, index) => {
                    const row = {
                        _key: index,
                        clientRowId: index,
                        mcp_server_id: (raw.mcp_server_id ?? '').trim(),
                        tool_name: (raw.tool_name ?? '').trim(),
                        description: raw.description ?? '',
                        parameters: raw.parameters ?? '',
                        supports_read: (raw.supports_read ?? '').trim(),
                        supports_write: (raw.supports_write ?? '').trim(),
                        supports_delete: (raw.supports_delete ?? '').trim(),
                    };
                    row._errors = validateToolRow(row);
                    return row;
                });

                if (rows.length === 0) {
                    resolve({ rows: [], fileErrors: ['No data rows found in the file'] });
                    return;
                }

                resolve({ rows, fileErrors: [] });
            },
            error: (error) => {
                resolve({ rows: [], fileErrors: [`Failed to read file: ${error.message}`] });
            },
        });
    });
};
